angular.module('unergie.main')
.controller('contractTagsCtrl', ($scope, $state, $uibModal, DataAccessTags, AlertManager, ErrorCatcher) => {
    $scope.isActive = (state) => $state.is(state)

    $scope.search = {
        text: undefined,
    }

    $scope.tags = undefined

    const tagTemplate = {
        text: '',
        color: '#ffffff',
        bgcolor: '#000000',
    }
    $scope.tagFields = {
        text: {
            label: 'Nom',
            required: true,
            placeholder: 'Nom',
            type: 'text',
        },
        color: {
            label: 'Couleur du texte',
            placeholder: 'Couleur du texte',
            type: 'color',
        },
        bgcolor: {
            label: 'Couleur du fond',
            placeholder: 'Couleur du fond',
            type: 'color',
        },
    }

    const resetTagPayload = () => ($scope.tagPayload = angular.copy(tagTemplate))

    resetTagPayload()

    const refresh = () => DataAccessTags.getRefContractTags().$promise.then((data) => ($scope.tags = data)).catch(ErrorCatcher)


    $scope.refresh = refresh
    refresh()

    $scope.updatePayload = (tag) => ($scope.tagPayload = angular.copy(tag))

    $scope.addTag = function () {
        $scope.tagPayload.text = $scope.tagPayload.text.trim()
        return DataAccessTags.addRefContractTag($scope.tagPayload).$promise.then(() => {
            AlertManager.success('Tag ajouté')
            resetTagPayload()
            return refresh() }).catch(ErrorCatcher)
    }

    $scope.updateTag = function (tag) {
        const tagPayload = angular.copy(tag)
        delete tagPayload.assignees
        delete tagPayload.id
        return DataAccessTags.updateRefContractTag({ id: tag.id }, tagPayload).$promise.then(() => {
            AlertManager.success('Tag modifié')
            return refresh()
        }).catch(ErrorCatcher)
    }

    $scope.deleteTag = (tag) =>
        DataAccessTags.deleteRefContractTag({ id: tag.id }).$promise.then(() => {
            AlertManager.success('Tag supprimé')
            return refresh()
        }).catch(ErrorCatcher)
})
